import BasicResource from '@/api/resource';

class SplitterResource extends BasicResource {

    constructor () {
        super('splitter');
    }

    splittersList (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/splitter',
            params: params,
        });
    }

    campaignTspList (campaignId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/splitter/campaigns/${campaignId}/tsp`,
            params: params,
        });
    }

    splitter (id) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/splitter/${id}`,
        });
    }

    createLinks (payload) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/splitter/links',
            data: payload,
        });
    }

    createOfferLinks (offerId, payload) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/splitter/links/offer/${offerId}`,
            data: payload,
        });
    }

    createPartnerLinks (partnerId, payload) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/splitter/links/partner/${partnerId}`,
            data: payload,
        });
    }

    partnerTrafficSplittersList (partnerId, params) {
        return this.splittersList({ ...params, partner_id: partnerId });
    }

    activate (splitterId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/splitter/${splitterId}/unpause`,
        });
    }

    pause (splitterId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/splitter/${splitterId}/pause`,
        });
    }

    changeDefaultOffer (splitterId, offerId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/splitter/${splitterId}/default-offer/${offerId}`,
        });
    }

    enableOffer (splitterId, offerId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/splitter/${splitterId}/enable-offer/${offerId}`,
        });
    }

    disableOffer (splitterId, offerId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/splitter/${splitterId}/disable-offer/${offerId}`,
        });
    }

    setAsDefault (splitterId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/splitter/${splitterId}/default`,
        });
    }

    unsetAsDefault (splitterId) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/splitter/${splitterId}/remove-default`,
        });
    }
}

export default new SplitterResource;
